import React from 'react';
import { HIAssemblyState } from './HIAssemblyModel';

export interface IHIAssemblyContext {
    currentHIAssemblyState: HIAssemblyState;
    setHIAssemblyState: React.Dispatch<HIAssemblyState>;
}

export const HIAssemblyContext = React.createContext({} as IHIAssemblyContext);
